import script from "./HrWorkforceSubTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./HrWorkforceSubTabs.vue?vue&type=script&setup=true&lang=js"

import "./HrWorkforceSubTabs.vue?vue&type=style&index=0&id=6fae7a2b&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fae7a2b"]])

export default __exports__